import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/WizardCampaign/TrainingModuleStep'

export const FETCH_TRAINING_VIDEOS_ASYNC = createAsyncTypes('FETCH_TRAINING_VIDEOS', typeKey)
export const UPLOAD_VIDEO_LINK_ASYNC = createAsyncTypes('UPLOAD_VIDEO_LINK', typeKey)
export const CREATE_CUSTOM_TRAINING_ASYNC = createAsyncTypes('CREATE_CUSTOM_TRAINING', typeKey)

export const SOURCE_FILTER_CHANGE = `${typeKey}/SOURCE_FILTER_CHANGE`
export const SEASON_FILTER_CHANGE = `${typeKey}/SEASON_FILTER_CHANGE`
export const LANGUAGE_FILTER_CHANGE = `${typeKey}/LANGUAGE_FILTER_CHANGE`
export const TYPE_FILTER_CHANGE = `${typeKey}/TYPE_FILTER_CHANGE`
export const SET_IS_VISITED = `${typeKey}/SET_IS_VISITED`
export const SHOW_SUBTITLE_CONTENT_CHANGE = `${typeKey}/SHOW_SUBTITLE_CONTENT_CHANGE`

// must be aligned with BE
export const SOURCE_VALUES = {
  IRONSCALES: 6,
  WIZER: 5,
  NINJIO: 1,
  HABITU8: 3,
  CYBERMANIACS: 4,
  CUSTOM_MODULE: 7,
}

export const isCustomSourceFilter = (sourceFilter) =>
  sourceFilter.includes(SOURCE_VALUES.CUSTOM_MODULE)

export const SOURCE_VALUE_BY_CATEGORY = {
  NINJIO: SOURCE_VALUES.NINJIO,
  IRONSCALES: SOURCE_VALUES.IRONSCALES,
  WIZER: SOURCE_VALUES.WIZER,
  'Custom Module': SOURCE_VALUES.CUSTOM_MODULE,
  'Cybermaniacs Videos': SOURCE_VALUES.CYBERMANIACS,
  Habitu8: SOURCE_VALUES.HABITU8,
}

export const CATEGORY_BY_SOURCE_VALUE = {
  [SOURCE_VALUES.IRONSCALES]: 'IRONSCALES',
  [SOURCE_VALUES.WIZER]: 'Wizer',
  [SOURCE_VALUES.NINJIO]: 'NINJIO',
  [SOURCE_VALUES.HABITU8]: 'Habitu8',
  [SOURCE_VALUES.CYBERMANIACS]: 'Cybermaniacs Videos',
  [SOURCE_VALUES.CUSTOM_MODULE]: 'Custom Module',
}

const PROVIDER_TAG_TONE_BY_VENDOR = {
  [SOURCE_VALUES.IRONSCALES]: {
    color: 'var(--primary)',
    textColor: 'var(--provider-tag-text-primary)',
  },
  [SOURCE_VALUES.WIZER]: {
    color: 'var(--positive-color)',
    textColor: 'var(--provider-tag-text-positive)',
  },
  [SOURCE_VALUES.NINJIO]: {
    color: 'var(--negative-color)',
    textColor: 'var(--provider-tag-text-negative)',
  },
  [SOURCE_VALUES.HABITU8]: {
    color: 'var(--warning-color)',
    textColor: 'var(--provider-tag-text-warning)',
  },
  [SOURCE_VALUES.CYBERMANIACS]: {
    color: 'var(--links-color)',
    textColor: 'var(--provider-tag-text-links)',
  },
}

export const getProviderTag = (vendor) => {
  const name = CATEGORY_BY_SOURCE_VALUE[vendor]

  if (!name || vendor === SOURCE_VALUES.CUSTOM_MODULE) return null

  return {
    label: vendor === SOURCE_VALUES.CYBERMANIACS ? 'Cybermaniacs' : name,
    ...PROVIDER_TAG_TONE_BY_VENDOR[vendor],
  }
}

export const SOURCE_OPTIONS = [
  { value: SOURCE_VALUES.IRONSCALES },
  { value: SOURCE_VALUES.WIZER },
  { value: SOURCE_VALUES.NINJIO },
  { value: SOURCE_VALUES.HABITU8 },
  { value: SOURCE_VALUES.CYBERMANIACS },
  { value: SOURCE_VALUES.CUSTOM_MODULE },
]

export const CONTENT_PACK_SOURCE_VALUES = [
  SOURCE_VALUES.NINJIO,
  SOURCE_VALUES.HABITU8,
  SOURCE_VALUES.CYBERMANIACS,
]

// Only those by requirements
export const VIDEO_SOURCE_WITH_SEASONS_MAP = {
  [SOURCE_VALUES.NINJIO]: true,
}

export const AUTOMATED_LEVEL_BASED_TRAINING_IMAGE_PATH = `${
  STATIC_BASE_URL || ''
}/static/webapp/images/Icon_white.png`

export const AUTOMATED_LEVEL_BASED_TRAINING = {
  id: 'AUTOMATED_LEVEL_BASED_TRAINING',
  name: 'Automated Level Based Training',
  vendor: SOURCE_VALUES.IRONSCALES,
  styles: {
    backgroundColor: '#0152cc',
    backgroundSize: '55px',
  },
  hasPermissions: true,
  items: [
    {
      imagePreview: AUTOMATED_LEVEL_BASED_TRAINING_IMAGE_PATH,
    },
  ],
  categories: [],
}

export const CUSTOM_MODULE_IMAGE_PREVIEW = `${
  STATIC_BASE_URL || ''
}/static/webapp/images/campaing-wizard/training-module/preview-image.svg`

export const CUSTOM_MODULE_NAME = 'Custom Content'
export const CUSTOM_MODULE_NAME_FILE = 'Custom Video - File'
export const CUSTOM_MODULE_NAME_URL = 'Custom Video - URL'

export const FREE_VIDEOS_LABEL = 'Free'

export const ALL_VIDEOS_LABEL = 'All'

export const PREMIUM_VENDORS_DETAILS = {
  [SOURCE_VALUES.HABITU8]: {
    title: 'Habitu8',
    description:
      'Habitu8’s Hashtag Awareness® live-action & animated series. Funny, short videos highlighting a single topic. Filmed in Hollywood, California - this series established the “Netflix-style” genre of training videos. You may recognize many of the actors on some of today’s hottest shows!(Parks & Rec, Marvel’s The Punisher, Brooklyn 99, Good Trouble, Rosewood, Gossip Girl, Grace & Frankie...just to name a few).',
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/training-videos-vendors/HABITU8-logo.svg`,
    categories: ['Recommended', 'Compliance and Regulations', 'New Employee', 'Security Awareness'],
  },
  [SOURCE_VALUES.NINJIO]: {
    description:
      'NINJIO AWARE™ Anime uses American anime cartoon characters to educate users about cybersecurity awareness. This video format uses NINJIO’s signature Hollywood-style storytelling that shapes the behavior of employees, staff, and team members to raise the security bar in the office and at home.',
    logo: `${
      STATIC_BASE_URL || ''
    }/static/webapp/images/training-videos-vendors/ninjio-vendor-logo.svg`,
    title: 'NINJIO AWARE™ Anime',
    categories: [
      'Recommended',
      'Phishing',
      'Security Awareness',
      'Compliance and Regulations',
      'New Employee',
    ],
  },
  [SOURCE_VALUES.IRONSCALES]: {
    description:
      'We take a multi-layered, employee-tailored approach to training, with the goal of reducing phishing clicks rates while improving the rate and speed of detection.',
    logo: `${
      STATIC_BASE_URL || ''
    }/static/webapp/images/training-videos-vendors/ironscales-blue-logo.svg`,
    title: 'IRONSCALES TRAINING ',
    categories: ['Recommended', 'Phishing', 'New Employee'],
  },
  [SOURCE_VALUES.CYBERMANIACS]: {
    description:
      'A cyber security awareness solution for organisations both large and small. Our cloud based platform is an interactive and engaging learning experience.',
    logo: `${
      STATIC_BASE_URL || ''
    }/static/webapp/images/training-videos-vendors/cyberManiacs-logo.svg`,
    title: 'CYBERMANIACS SECURITY AWARENESS',
    categories: ['Recommended', 'Phishing', 'Security Awareness'],
  },
  [SOURCE_VALUES.WIZER]: {
    description: `No-nonsense 1-minute 
      training videos that your team will LOVE to watch! 
      Teach your colleagues how to avoid being tricked by 
      cyber criminals by choosing from a comprehensive set of Cyber Security 
      Awareness training videos, including Phishing, Best Practices, 
      Wire Fraud, Common Scams, Mobile, and more.
    `,
    logo: `${STATIC_BASE_URL || ''}/static/webapp/images/training-videos-vendors/wizer-logo.svg`,
    title: 'Wizer',
    categories: [
      'Recommended',
      'Phishing',
      'Security Awareness',
      'Compliance and Regulations',
      'New Employee',
    ],
  },
}

export const TRAINING_VIDEO_TYPES = {
  VIDEO: {
    label: 'Video',
    value: 'VIDEO',
  },
  COURSE: {
    label: 'Course',
    value: 'COURSE',
  },
  QUIZ_HTML5: {
    label: 'Quiz',
    value: 'QUIZ_HTML5',
  },
  CUSTOM_CONTENT: {
    label: 'Custom Content',
    value: 'CUSTOM_CONTENT',
  },
  ALL: {
    label: 'All',
    value: 'ALL',
  },
}

export const CUSTOM_MODULE_TYPES = {
  CUSTOM_VIDEO: 'CUSTOM_VIDEO',
  CUSTOM_URL: 'CUSTOM_URL',
}

export const SIZE_LIMITS = {
  small: {
    size: 50 * 1024 * 1024,
    label: '50MB',
  },
  default: {
    size: 200 * 1024 * 1024,
    label: '200MB',
  },
  increased: {
    size: 2 * 1024 * 1024 * 1024,
    label: '2GB',
  },
}

export const FILE_INPUT_ID = 'TrainingModule_CustomVideoUploadFile_input'

export const TRAINING_VIDEO_SELECTED_MESSAGE = 'Training Module Selected'
